<template>
    <v-layout>
        <v-flex>
            <v-card>
                <v-card-title>
                    <h3 class="headline mb-0 admin-header">Integration Tokens</h3>
                    <v-btn text icon color="grey lighten-1" @click="refresh(pagination)"><v-icon>fas fa-sync</v-icon></v-btn>
                </v-card-title>
                <v-card-text>
                    <v-layout wrap>
                        <v-flex xs12>
                            <v-data-table
                              :items="integrationTokens"
                              :loading="loading"
                              :headers="headers"
                               class="elevation-1"
                            >
                              <template v-slot:item.name="{item}">
                                <td>
                                    <router-link to="" @click.native="editItem(item)">{{item.name}}</router-link>
                                </td>
                              </template>
                              <template v-slot:item.updatedDate="{item}">
                                <td>{{formatDateTime(item.updatedDate)}}</td>
                              </template>
                              <template v-slot:item.deleted="{item}">
                                <td>{{item.deleted ? 'yes' : 'no' }}</td>
                              </template>
                              <template v-slot:item.actions="{item}">
                                <td>
                                    <v-btn text icon @click="editItem(item)" style="height: 0px; width: 0px; padding-right:2px;">
                                        <v-icon color="grey lighten-1" style="font-size: 18px;" >fas fa-pencil</v-icon>
                                    </v-btn>
                                    <v-spacer></v-spacer>
                                    <v-btn text icon @click="deleteItem(item)" style="height: 0px; width: 0px; padding-right:2px;">
                                        <v-icon color="grey lighten-1" style="font-size: 18px;" >fas fa-trash</v-icon>
                                    </v-btn>
                                </td>
                              </template>
                            </v-data-table>
                        </v-flex>
                    </v-layout>
                </v-card-text>
                <v-card-actions>
                    <button class="btn btn-primary" @click="newItem()">New Token</button>
                </v-card-actions>
            </v-card>
            <v-dialog v-model="showEditDialog" max-width="600px">
                <v-card>
                    <v-card-title>
                    <span class="headline">Integration Token</span>
                    </v-card-title>

                    <v-card-text>
                        <v-form v-model="validItem" @submit.prevent>
                        <v-container grid-list-md>
                            <v-layout wrap>
                                <v-flex xs12 class="subheading">
                                   Id: {{editedItem.id}}
                                </v-flex>
                                <v-flex xs2 ml-4>
                                    <v-autocomplete
                                    v-model="editedItem.org.id"
                                    :items="organizations"
                                    label="Organization"
                                        item-text="text"
                                        item-value="value">
                                    </v-autocomplete>
                                </v-flex>
                                <v-flex xs12 sm6 md6>
                                    <v-text-field v-model="editedItem.key" :rules="[rules.required]" label="Key"></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md6>
                                    <v-text-field v-model="editedItem.token" :rules="[rules.required]" label="Token"></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md6>
                                    <v-text-field v-model="editedItem.system.id" label="System Id"></v-text-field>
                                </v-flex>
                                <v-flex xs3>
                                    <v-checkbox v-model="editedItem.deleted" label="Deleted"></v-checkbox>
                                </v-flex>
                            </v-layout>
                        </v-container>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn text color="blue darken-1" @click.native="close">{{'Cancel'}}</v-btn>
                        <v-btn text color="blue darken-1" :disabled="!validItem" @click.native="save">Save</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-flex>
    </v-layout>
</template>
<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import _ from 'lodash'
import moment from 'moment'
import Utility from './utility'
export default {
    computed: {
        ...mapGetters('user', {
            organizations: 'getOrganizationsTextValue',
            isSUPro: 'isSUPro'
        }),
        ...mapGetters('menus', {
          findRouteTitle: 'findRouteTitle'
        }),
        routeTitle: {
          get() {
            return this.findRouteTitle(this.$route.name) || this.title
          }
        }
    },
    data() {
        return {
            integrationTokens: [],
            loading: false,
            search: '',
            pagination : {
                    descending: true,
                    page: 1,
                    rowsPerPage: 10, // -1 for All",
                    sortBy: ["updatedDate"]
            },
            totalItems: 0,
            headers: [
                {text: 'Id', align: 'left', sortable: true, value: 'id'},
                {text: 'Org Id', align: 'left', sortable: true, value: 'org.id'},
                {text: 'Org Name', align: 'left', sortable: true, value: 'org.name'},
                {text: 'Key', align: 'left', sortable: true, value: 'key'},
                {text: 'Token', align: 'left', sortable: true, value: 'token'},
                {text: 'System Id', align: 'left', sortable: true, value: 'system.id'},
                {text: 'System Name', align: 'left', sortable: false, value: 'system.name'},
                {text: 'Updated Date', align: 'left', sortable: true, value: 'updatedDate'},
                {text: 'Updated By', align: 'left', sortable: true, value: 'updatedBy'},
                {text: 'Deleted', align: 'left', sortable: true, value: 'deleted'},
                {text: 'Actions', align: 'left', sortable: false, value: 'actions'}
            ],
            rules: {
                required: value => !!value || 'Required.',
                numeric: value => !value || Number.isInteger(+value) || 'Invalid format'
            },
            valid: false,
            validItem: false,
            showEditDialog: false,
            originalItem: null,
            editedItem: {
                id: -1,
                key: '',
                token: '',
                org: {id: '', name: ''},
                system: {id: '', name: ''}
            },
            defaultItem: {
                id: -1,
                key: '',
                token: '',
                org: {id: '', name: ''},
                system: {id: '', name: ''}
            }
        }
    },
    watch: {
        pagination: {
            async handler () {
                await this.refresh(this.pagination)
            }, deep: true
        }
    },
    methods: {
        async refresh(pagination) {

            this.loading = true

            this.integrationTokens = await this.$store.dispatch('crossorg/getIntegrationTokens')

            this.totalItems = this.integrationTokens.length

            this.loading = false
        },
        formatDateTime(val) {
            return moment(val).isValid() ? moment(val).format('MM/DD/YYYY, h:mm:ss a') : val
        },
        async editItem (item) {
            this.originalItem = item
            this.editedItem = Object.assign({}, item)
            this.showEditDialog = true
        },
        close() {
            this.showEditDialog = false
            setTimeout(() => {
                this.editedItem = Object.assign({}, this.defaultItem)
                this.originalItem = null
            }, 300)
        },
        async save () {

            await this.$store.dispatch("crossorg/upsertIntegrationToken", {integrationToken: this.editedItem})
            this.close()

            await this.refresh(this.pagination)
        },
        newItem() {
            this.editedItem = Object.assign({}, this.defaultItem)
            this.originalItem = null
            this.showEditDialog = true
        },
        async deleteItem(item) {
            if (confirm('Do you wish to permanently delete this item?')) {
                await this.$store.dispatch("crossorg/deleteIntegrationToken", {integrationToken: item})
                await this.refresh(this.pagination)
            }
        }
    }
}
</script>
